/**
 * Search Container Observer Script
 * Monitors changes to the boost instant search container on search template pages
 */

(function () {
  'use strict';

  // Check if we're on a search template page
  function isSearchTemplatePage() {
    return document.body.classList.contains('templateSearch');
  }

  // Get the triggering element by checking recent user interactions
  function getLastInteractionElement() {
    // Check for recently focused elements
    const activeElement = document.activeElement;

    if (activeElement && activeElement !== document.body) {
      return activeElement;
    }

    // Check for elements with recent mouse events
    const recentlyHovered = document.querySelector(':hover');

    if (recentlyHovered) {
      return recentlyHovered;
    }

    return null;
  }

  // Process search container changes
  function processSearchContainerChange(mutationType, target, triggeringElement) {
    // Hide search widget wrapper if triggered by search form input
    hideSearchWidgetIfTriggeredByInput(target, triggeringElement);
  }

  // Hide search widget wrapper when triggered by specific search form input
  function hideSearchWidgetIfTriggeredByInput(target, triggeringElement) {
    // Check if target is the search widget wrapper
    if (target && target.id === 'boost-sd__search-widget-init-wrapper') {
      if (triggeringElement && triggeringElement.classList) {
        // Hide ONLY if triggered by boost-sd__search-form-input (first input type)
        if (triggeringElement.classList.contains('boost-sd__search-form-input')) {
          // Hide the search widget wrapper
          target.style.display = 'none';
        }
        // Show if triggered by js-search-input (second input type)
        else if (triggeringElement.classList.contains('js-search-input')) {
          // Ensure the search widget wrapper is visible
          target.style.display = '';
        }
      }
    }
  }

  // Set up the mutation observer
  function setupSearchContainerObserver() {
    const searchContainer = document.querySelector('#boost-sd__instant-search-container');

    if (!searchContainer) {
      return;
    }

    // Create mutation observer
    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        const triggeringElement = getLastInteractionElement();

        switch (mutation.type) {
          case 'childList':
            if (mutation.addedNodes.length > 0) {
              processSearchContainerChange('Child Added', mutation.target, triggeringElement);
            }

            if (mutation.removedNodes.length > 0) {
              processSearchContainerChange('Child Removed', mutation.target, triggeringElement);
            }

            break;

          case 'attributes':
            processSearchContainerChange('Attribute Changed', mutation.target, triggeringElement);

            break;

          case 'characterData':
            processSearchContainerChange('Text Content Changed', mutation.target, triggeringElement);

            break;
        }
      });
    });

    // Configure observer options
    const observerConfig = {
      // Watch for child node additions/removals
      childList: true,
      // Watch all descendants
      subtree: true,
      // Watch for attribute changes
      attributes: true,
      // Include old attribute values
      attributeOldValue: true,
      // Watch for text content changes
      characterData: true,
      // Include old text content
      characterDataOldValue: true,
    };

    // Start observing
    observer.observe(searchContainer, observerConfig);

    // Also set up event listeners for common search triggers
    setupSearchEventListeners();
  }

  // Set up event listeners for search-related interactions
  function setupSearchEventListeners() {
    // Listen for input events on search fields
    document.addEventListener('input', function (event) {
      const target = event.target;

      if (
        target.type === 'search' ||
        target.classList.contains('search') ||
        target.name === 'q' ||
        target.id.includes('search')
      ) {
        // Search input detected
      }
    });

    // Listen for form submissions
    document.addEventListener('submit', function (event) {
      const form = event.target;

      if (
        form.classList.contains('search') ||
        form.querySelector('input[type="search"]') ||
        form.querySelector('input[name="q"]')
      ) {
        // Search form detected
      }
    });

    // Listen for clicks on search-related elements
    document.addEventListener('click', function (event) {
      const target = event.target;

      if (
        target.classList.contains('search') ||
        target.closest('.search') ||
        (target.type === 'submit' && target.closest('form').querySelector('input[type="search"]'))
      ) {
        // Search element clicked
      }
    });
  }

  // Initialize when DOM is ready
  function initialize() {
    if (!isSearchTemplatePage()) {
      return;
    }

    // Wait for the search container to be available
    const checkForContainer = setInterval(function () {
      const container = document.querySelector('#boost-sd__instant-search-container');

      if (container) {
        clearInterval(checkForContainer);
        setupSearchContainerObserver();
      }
    }, 100);

    // Stop checking after 10 seconds
    setTimeout(function () {
      clearInterval(checkForContainer);
    }, 10000);
  }

  // Run when DOM is loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();
